import Link from "next/link"
import AccountBoxIcon from "@material-ui/icons/AccountBox"
import LocalAtmIcon from "@material-ui/icons/LocalAtm"
import AnnouncementIcon from "@material-ui/icons/Announcement"
import TuneIcon from "@material-ui/icons/Tune"
import TwilioIcon from "@material-ui/icons/Settings"
import AppLayout from "@/components/AppLayout"
import PasswordIcon from "@material-ui/icons/Lock"

export default function Account(): JSX.Element {
  return <AppLayout requiredAuth="user">
    <section className="flex flex-col items-center w-full">
      <div className="flex flex-col items-center my-12">
        <h1 className="text-3xl sm:text-4xl font-display">
          {"Account Settings"}
        </h1>
        <h3 className="text-gray-600 opacity-75">
          {"Choose an option below..."}
        </h3>
      </div>
      <div className="w-full flex flex-row flex-wrap items-center justify-center px-12">
        <Link href="/account/contact">
          <a
            className={
              "flex flex-col items-center " +
              " font-display text-xl box-shadow-subtle p-4 mx-8 mb-8 bg-ppt-blue-800 rounded hover-scale text-center" +
              " text-ppt-blue"
            }
          >
            <AccountBoxIcon
              style={{ height: "6rem", width: "6rem" }}
            />
            {"Contact Info"}
          </a>
        </Link>
        <Link href="/account/password">
          <a
            className={
              "flex flex-col items-center " +
              " font-display text-xl box-shadow-subtle p-4 mx-8 mb-8 bg-ppt-blue-800 rounded hover-scale text-center text-yellow-500"
            }
          >
            <PasswordIcon
              style={{ height: "6rem", width: "6rem" }}
            />
            {"Password"}
          </a>
        </Link>
        <Link href="/account/billing">
          <a
            className={
              "flex flex-col items-center " +
              " font-display text-xl box-shadow-subtle p-4 mx-8 mb-8 bg-ppt-blue-800 rounded hover-scale text-center" +
              " text-ppt-success"
            }
          >
            <LocalAtmIcon
              style={{ height: "6rem", width: "6rem" }}
            />
            {"Billing"}
          </a>
        </Link>
        <Link href="/account/notifications">
          <a
            className={
              "flex flex-col items-center " +
              " font-display text-xl box-shadow-subtle p-4 mx-8 mb-8 bg-ppt-blue-800 rounded hover-scale text-center" +
              " text-ppt-caution"
            }
          >
            <AnnouncementIcon
              style={{ height: "6rem", width: "6rem" }}
            />
            {"Notifications"}
          </a>
        </Link>
        <Link href="/account/integrations">
          <a
            className={
              "flex flex-col items-center " +
              " font-display text-xl box-shadow-subtle p-4 mx-8 mb-8 bg-ppt-blue-800 rounded hover-scale text-center" +
              " text-ppt-red"
            }
          >
            <TuneIcon style={{ height: "6rem", width: "6rem" }}/>
            {"Integrations"}
          </a>
        </Link>
        <Link href="/account/twilio">
          <a
            className={
              "flex flex-col items-center " +
              " font-display text-xl box-shadow-subtle p-4 mx-8 mb-8 bg-ppt-blue-800 rounded hover-scale text-center text-purple-500"
            }
          >
            <TwilioIcon
              style={{ height: "6rem", width: "6rem" }}
            />
            {"Twilio"}
          </a>
        </Link>
      </div>
    </section>
  </AppLayout>
}